<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link :to="{ name: 'Home' }">{{$t('nav.home')}}</router-link>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          {{$t('nav.establishments')}}
        </li>
      </ol>
    </nav>
    <b-row>
      <b-col>
        <b-form-group
          label="Filtrer"
          label-cols-sm="3"
          label-align-sm="left"
          label-size="sm"
          label-for="filterInput"
        >
          <b-input-group size="sm">
            <b-form-input
              id="filterInput"
              v-model="filter"
              type="search"
              :placeholder="$t('placeholder.find_esta')"
            />
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''"
                >{{$t('btn.erase')}}</b-button
              >
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-container>
      <b-row cols="3" align-v="baseline">
        <b-col cols="1" sm="9">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            aria-controls="table_estas"
            first-text="⏮"
            prev-text="⏪"
            next-text="⏩"
            last-text="⏭"
            align="fill"
            first-number
            last-number
          >
            <template #page="{ page, active }">
              <b v-if="active">{{ page }}</b>
              <i v-else>{{ page }}</i>
            </template>
          </b-pagination>
        </b-col>
        <b-col cols="1" sm="1" class="text-right">Lignes </b-col>
        <b-col cols="1" sm="2" calss="text-left">
          <b-form-select
            id="lignes"
            v-model="perPage"
            :options="optionsLignes"
            value-field="item"
            text-field="name"
          ></b-form-select>
        </b-col>
      </b-row>
    </b-container>
    <b-table
      id="table_estas"
      :per-page="perPage"
      :current-page="currentPage"
      :fields="fields"
      :items="establishments"
      :filter="filter"
      :filter-included-fields="filterOn"
      small
      responsive="sm"
      @row-dblclicked="onDblClicked"
      @filtered="onFiltered"
    >
      <template #cell(cest_cont_id)="data">
        <b-button
          v-if="data.value"
          :to="{ name: 'ContractDetails', params: { id: data.value } }"
          variant="outline-primary"
          >{{ data.value }}</b-button
        >
        <div v-else><i>Non lié</i></div>
      </template>
      <template #cell(esta_name)="row">
        <div v-if="edit === row.index">
          <b-form @submit="onSubmit">
            <b-form-group>
              <b-input-group size="sm">
                <b-form-input
                  v-model="row.item.esta_name"
                  :id="'edit' + row.item.esta_id"
                >
                  {{ row.item.esta_name }}
                </b-form-input>
                <b-input-group-append>
                  <b-button type="submit" variant="success">
                    <font-awesome-icon :icon="['fas', 'check']" />
                  </b-button>
                </b-input-group-append>
                <b-input-group-append>
                  <b-button type="close" variant="danger" @click="onCancel">
                    <font-awesome-icon :icon="['fas', 'times']" />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-form>
        </div>
        <div v-else>
          {{ row.item.esta_name }}
        </div>
      </template>
      <template #cell(tags)="row" class="text-center">
        <b-row
          v-for="tag in row.item.tags"
          :key="'estatag-' + row.item.esta_id + tag.tag_id"
          class="text-center"
        >
          <b-col class="text-center">
            <b-badge :style="{ 'background-color': tag.tag_color }">{{
              tag.tag_name
            }}</b-badge>
          </b-col>
        </b-row>
      </template>
      <template #cell(details)="row">
        <b-button
          v-if="row.item.esta_id"
          :to="{
            name: 'EstablishmentDetails',
            params: { id: row.item.esta_id },
          }"
          variant="outline-primary"
          >Détails</b-button
        >
      </template>
    </b-table>
  </div>
</template>
<script>
import ListStaff from "../components/lists/ListStaff.vue";
import ListParticipants from "../components/lists/ListParticipants.vue";
import { getAllEstablishment } from "../services/establishment";

export default {
  components: {
    ListStaff,
    ListParticipants,
  },
  data() {
    return {
      perPage: 50,
      currentPage: 1,
      totalRows: 1,
      optionsLignes: [
        { item: 10, name: "10" },
        { item: 20, name: "20" },
        { item: 30, name: "30" },
        { item: 50, name: "50" },
        { item: 100, name: "100" },
        { item: 200, name: "200" },
      ],
      fields: [
        {
          esta_id: {
            label: "Id",
            sortable: true,
            tdClass: "align-middle",
          },
        },
        {
          cest_cont_id: {
            label: "Contrat lié",
            sortable: true,
            tdClass: "align-middle",
          },
        },
        {
          esta_name: {
            label: "Établissements",
            sortable: true,
            tdClass: "align-middle",
          },
        },
        {
          tags: {
            label: "Tags",
            sortable: false,
            tdClass: "align-middle",
            filterByFormatted: true,
          },
        },
        {
          details: {
            label: "Détails",
            sortable: false,
            tdClass: "align-middle",
          },
        },
      ],
      filter: null,
      filterOn: [],
      edit: -1,
      listToShow: "staff",
      dupEstablishment: null,
      establishments: null,
    };
  },
  // computed: mapState({
  //   establishments: (state) => state.establishments.all,
  // }),
  async created() {
    //this.$store.dispatch("establishments/getAllEstablishments");
    this.establishments = await getAllEstablishment();
    this.totalRows = this.establishments.length;
  },
  methods: {
    onDblClicked(item, index) {
      this.edit = index;
    },
    onSubmit(event) {
      event.preventDefault();
      // console.log(event);
      // TODO : Envoyer modification du nom
      this.edit = -1;
    },
    onCancel(event) {
      event.preventDefault();
      this.edit = -1;
    },
    onToggleStaff(currentRow) {
      if (currentRow.detailsShowing && this.listToShow !== "staff") {
        currentRow.toggleDetails();
      }
      this.listToShow = "staff";
      currentRow.toggleDetails();
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
};
</script>

